import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {locationShape, routerShape, withRouter} from 'react-router';

import {withConfig, withI18n} from 'spa/Components/Context';

import FindAppointmentNewForDigital from './digital/FindAppointmentNewForDigital';
import FindAppointmentForNext from './FindAppointmentForNext';

import './find-appointment-for-next.less';

@withRouter
@inject(({
  store: {
    session,
    tracker,
  },
}) => ({
  session,
  tracker,
}))
@observer
@withConfig
@withI18n
class AddressSectionWrapper extends React.Component {
  static propTypes = {
    isLandingPage: PropTypes.bool,
    location: locationShape.isRequired,
    phoneNumberFormatted: PropTypes.string,
    phoneNumberHuman: PropTypes.string,
    router: routerShape.isRequired,
    session: PropTypes.shape({
      user: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      }),
    }).isRequired,
    subTitle: PropTypes.string,
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    title: PropTypes.string,
    trackingCategory: PropTypes.string,
    trackingLocation: PropTypes.string,
  };

  static defaultProps = {
    trackingCategory: 'Booking',
  }

  render() {
    const {
      isLandingPage,
      location: {
        query,
      },
      phoneNumberFormatted,
      phoneNumberHuman,
      title,
      subTitle,
      trackingCategory,
      trackingLocation,
    } = this.props;

    // We want to force the old flow in the e2e tests
    // TODO Remove when removing the old booking flow completly
    if (query && query.e2etest) {
      return (
        <FindAppointmentNewForDigital
          title={title}
          subTitle={subTitle}
          phoneNumberHuman={phoneNumberHuman}
          phoneNumberFormatted={phoneNumberFormatted}
          roundInputBox
          trackingCategory={trackingCategory}
          trackingLocation={trackingLocation}
          isLandingPage={isLandingPage}
        />
      );
    }

    return (
      <FindAppointmentForNext
        title={title}
        subTitle={subTitle}
        roundInputBox
        trackingCategory={trackingCategory}
        trackingLocation={trackingLocation}
      />
    );
  }
}

export default AddressSectionWrapper;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/AddressSectionWrapper.jsx